import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import DialogueBase from '../../../components/dialogues/DialogueBase';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: '45rem',
  },
  section: {
    marginBottom: '2rem',
  }
}));

const PlatformEmailDialogue = ({open, onClose}) => {
  const classes = useStyles();
  return (
    <DialogueBase open={open} onClose={onClose} title="Important information about your Clickability vault address.">
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.center}>
          <div className={classes.root}>
            <div className={classes.section}>
              <Typography variant="h3" paragraph>
                <b>What is my Clickability vault address?</b>
              </Typography>
              <Typography variant="body2" paragraph>
                This is a special email address that you can use to send attached documents directly to your Clickability vault. It is <b>not a fully featured email service</b> and is intended only as a simpler means to add documents to your vault.
              </Typography>
              <Typography variant="body2" paragraph>
                Any documents attached to emails that are sent to this address will be stored on Clickability. You can then categorise, search and access your documents whenever you need them. No more searching your hard drive for that service agreement or invoice you got 6 months ago but can&apos;t find now!
              </Typography>
              <Alert severity="warning">Your Clickability vault address is not a replacement for your personal email. It is designed to capture attached documents, it does not offer full email sending and receiving functionality.</Alert>
            </div>
            <div className={classes.section}>
              <Typography variant="h3" paragraph>
                <b>How do I use my Clickability vault address?</b>
              </Typography>
              <Typography variant="body2" paragraph>
                It&apos;s really simple, just send create a new email in your normal email system (e.g. GMail), attach any document you want and send it to your vault address. The document should appear in your vault within a few minutes. That&apos;s it, your documents will appear in Clickability as they are received!
              </Typography>
              <Alert severity="warning">Documents sent to your vault address can be no larger than 20MB. To upload larger documents, please use the Upload button on the web site.</Alert>
            </div>
            <div className={classes.section}>
              <Typography variant="h3" paragraph>
                <b>Can I change my vault email address?</b>
              </Typography>
              <Typography variant="body2" paragraph>
                Your vault address is generated automatically based on your user name. It can&apos;t be changed right now however, we may provide this feature in the future. If it&apos;s important to you, please let us know.
              </Typography>
            </div>
          </div>
        </Grid>
      </Grid>
    </DialogueBase>
  );
};

PlatformEmailDialogue.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PlatformEmailDialogue;
